import { Outlet } from "react-router-dom"

const BlankLayout = () => {
    return (
        <div className="front-end-style"> <Outlet /></div>
    )
}

export default BlankLayout;